import { Suspense, useMemo, useState } from 'react';

// * API
import { useGetEnergyDataQuery } from '../../../../api/energy-analysis/energyDataApiSlice';

// * Components
import GatewayLoadingIndicator from '@/components/indicators/GatewayLoadingIndicator';
import OrgChartComponent from '@/features/energyxplorer/components/tree-graph/OrgChart';

const EnergyTreeGraphTab = ({
  selectedEnergyGroup,
  units,
  timeRange,
  setNodeToAnalyse,
  setValue,
  setTimestampSummary,
  setTimestampSummarySetBy,
}) => {
  const [filters, setFilters] = useState({
    activeHoursFilter: undefined,
    activeDaysFilter: undefined,
    activeHolidaysFilter: undefined,
  });

  const queryArgs = useMemo(() => {
    return {
      accountId: selectedEnergyGroup?.accountId,
      energyGroupId: selectedEnergyGroup?.energyGroupId,
      start: timeRange?.start,
      end: timeRange?.end,
      activeHoursFilter: filters.activeHoursFilter,
      activeDaysFilter: filters.activeDaysFilter,
      activeHolidaysFilter: filters.activeHolidaysFilter,
    };
  }, [
    selectedEnergyGroup?.accountId,
    selectedEnergyGroup?.energyGroupId,
    timeRange?.start,
    timeRange?.end,
    filters.activeHoursFilter,
    filters.activeDaysFilter,
    filters.activeHolidaysFilter,
  ]);

  const {
    data: energyData,
    isLoading: isLoadingEnergyData,
    isFetching: isFetchingEnergyData,
  } = useGetEnergyDataQuery(queryArgs, {
    refetchOnMountOrArgChange: true,
  });

  const enhancedEnergyGroup = useMemo(() => {
    if (!selectedEnergyGroup || !energyData?.NodeEnergySummaries)
      return selectedEnergyGroup;

    if (energyData?.TimestampsSummary) {
      setTimestampSummary(energyData.TimestampsSummary);
      setTimestampSummarySetBy('Neddeling');
    }

    const summaryMap = energyData.NodeEnergySummaries.reduce((acc, summary) => {
      acc[summary.Id] = summary;
      return acc;
    }, {});

    const enhancedNodes = selectedEnergyGroup.energyTreeNodes.map((node) => ({
      ...node,
      energySummary: summaryMap[node.energyTreeNodeId] || null,
    }));

    return {
      ...selectedEnergyGroup,
      energyTreeNodes: enhancedNodes,
    };
  }, [
    selectedEnergyGroup,
    energyData?.NodeEnergySummaries,
    energyData?.TimestampsSummary,
    setTimestampSummary,
    setTimestampSummarySetBy,
  ]);

  return (
    <>
      <Suspense fallback={<div>Loading TreeComponent...</div>}>
        <GatewayLoadingIndicator
          isLoading={isLoadingEnergyData || isFetchingEnergyData}
        />
      </Suspense>
      <Suspense fallback={<div>Loading TreeComponent...</div>}>
        <OrgChartComponent
          selectedEnergyGroup={enhancedEnergyGroup || {}}
          data={enhancedEnergyGroup?.energyTreeNodes || []}
          units={units}
          setNodeToAnalyse={setNodeToAnalyse}
          setValue={setValue}
          setFilters={setFilters}
        />
      </Suspense>
    </>
  );
};

export default EnergyTreeGraphTab;
